import { defineComponent as _defineComponent } from 'vue';
import { ref, watch } from 'vue';
import { EFormItemType } from '@blade-sxp/record-center/interfaces/attendanceRecord';
import LibPortaitSearchItem from '@blade-sxp/record-center/components/search-items/portait-libray.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'searchForm',
    props: {
        form: {
            type: Object,
            default: () => ({}),
        },
        config: {
            type: Object,
            default: () => ({}),
        },
        btns: {
            type: Array,
            default: () => [],
        },
    },
    emits: ['change', 'update:form', 'handleClickBtn'],
    setup(__props, { emit }) {
        const props = __props;
        const curForm = ref({});
        watch(() => props.form, (nv) => {
            curForm.value = nv;
        }, { deep: true, immediate: true });
        function handleChange(val) {
            emit('change', { ...curForm.value });
        }
        function handleClickBtn(k) {
            emit('handleClickBtn', { type: k, data: { ...curForm.value } });
        }
        return { __sfc: true, props, curForm, emit, handleChange, handleClickBtn, EFormItemType, LibPortaitSearchItem };
    }
});
